// One place for the facts the site states about the business, so the page
// text, the canonical links and the structured data (JSON-LD) always agree.

// The one address the site lives at. Search Console reports this host as the
// main home page; the www host should redirect here.
export const SITE_URL = 'https://paint-it-better.com';

export const BUSINESS = {
  name: 'Paint It Better',
  legalName: 'Paint It Better Ltd',
  email: 'hello@paint-it-better.com',
  logo: '/images/emergent/logo.png',
  image: '/images/emergent/hero-background.jpg',
  // Link previews (WhatsApp, Facebook): 1200x630 and under 300 KB, or
  // WhatsApp drops it and shows a blurry logo instead.
  shareImage: '/images/share.jpg',
  address: {
    addressLocality: 'Wye, Ashford',
    addressRegion: 'Kent',
    postalCode: 'TN25 5AS',
    addressCountry: 'GB',
  },
  areaServed: ['Wye', 'Ashford', 'Canterbury', 'Maidstone', 'Folkestone', 'Faversham', 'Tenterden', 'Cranbrook', 'Kent'],
  sameAs: [
    'https://www.checkatrade.com/trades/PaintItBetterLtd',
    'https://www.facebook.com/paint.it.better.uk',
  ],
};

// Romeo's mobile, used for the WhatsApp button and in the business details
// Google reads. Write it as a UK number (07...) or with +44.
const MOBILE = '07931 314200';
const phoneDigits = (() => {
  const digits = MOBILE.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('0')) return `44${digits.slice(1)}`;
  return digits;
})();
export const PHONE = phoneDigits ? `+${phoneDigits}` : '';
export const WHATSAPP_MESSAGE = "Hi Romeo, I found Paint It Better online and I'd like a quote.";
export const whatsappUrl = () =>
  phoneDigits ? `https://wa.me/${phoneDigits}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}` : '';

// Who writes the blog posts. Change the name or role here only.
export const AUTHOR = {
  name: 'Romeo Taullaj',
  jobTitle: 'Owner',
  url: '/about',
};

// "owner of Paint It Better", as shown after the author's name on posts.
export const authorRole = () => `${AUTHOR.jobTitle.toLowerCase()} of ${BUSINESS.name}`;

// Absolute URL on the canonical host. Links stored with either host
// (www or not) are moved onto SITE_URL; links to other sites are left alone.
export function absoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return SITE_URL;
  const own = pathOrUrl.match(/^https?:\/\/(?:www\.)?paint-it-better\.com(\/.*)?$/i);
  if (own) return `${SITE_URL}${own[1] && own[1] !== '/' ? own[1] : '/'}`;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;
}
